export enum Event3sType {
  ResponseReceived = "ResponseReceived",
  ResultsRendered = "ResultsRendered",
  SearchEntityClicked = "SearchEntityClicked",
  SearchEntityActions = "SearchEntityActions",
  ClientLayout = "ClientLayout",
  EntityActionTaken = "EntityActionTaken",
}

export enum EntityActionTakenType {
  CopyLink = "CopyLink",
  SendCopy = "SendCopy",
  Share = "Share",
  Download = "Download",
  Unsubscribe = "Unsubscribe",
}
